/* Page ma débarbouillette (15-10-2026) : compte à rebours, menu, galerie, offres, avis. Code maison. */
(function () {
  /* Pas de zoom (pincement ni double tap) : la page se lit uniquement de haut en bas */
  ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (t) { document.addEventListener(t, function (e) { e.preventDefault(); }, { passive: false }); });
  document.addEventListener('touchmove', function (e) { if (e.touches.length > 1 || (e.scale && e.scale !== 1)) e.preventDefault(); }, { passive: false });
  var lastTap = 0;
  document.addEventListener('touchend', function (e) { var now = Date.now(); if (now - lastTap < 300 && !e.target.closest('button, a, label, summary, input')) e.preventDefault(); lastTap = now; }, { passive: false });

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Compte à rebours comme l'original : jusqu'au 31-10-2026 23:59:59 (heure du visiteur), jours masqués ; ensuite seul « L'offre se termine dans : » reste */
  var timer = $('[data-ecv-timer]');
  if (timer) {
    var END = new Date(2026, 9, 31, 23, 59, 59).getTime();
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var iv;
    var tick = function () {
      var left = Math.floor((END - Date.now()) / 1000);
      if (left <= 0) {
        timer.hidden = true; $('[data-ecv-live]').hidden = true; $('[data-ecv-ended]').hidden = false;
        clearInterval(iv); return;
      }
      $('[data-h]', timer).textContent = pad(Math.floor(left % 86400 / 3600));
      $('[data-m]', timer).textContent = pad(Math.floor(left % 3600 / 60));
      $('[data-s]', timer).textContent = pad(left % 60);
    };
    tick(); iv = setInterval(tick, 1000);
  }

  /* En-tête collant : se cache en descendant, revient dès qu'on remonte */
  var header = $('.ecv-header'), lastY = window.scrollY;
  if (header) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (drawer && !drawer.hidden) { lastY = y; return; }
      var limit = (header.previousElementSibling ? header.previousElementSibling.offsetHeight : 0) + header.offsetHeight;
      header.classList.toggle('is-hidden', y > lastY && y > limit);
      lastY = y;
    }, { passive: true });
  }

  /* Menu tiroir : pleine largeur sous l'en-tête, le burger devient une croix */
  var drawer = $('[data-ecv-drawer]'), burger = $('[data-ecv-menu-open]');
  var closeDrawer = function () { drawer.hidden = true; document.body.style.overflow = ''; burger.classList.remove('is-open'); };
  if (drawer && burger) {
    burger.addEventListener('click', function () {
      if (!drawer.hidden) { closeDrawer(); return; }
      drawer.style.setProperty('--ecv-drawer-top', header.getBoundingClientRect().bottom + 'px');
      drawer.hidden = false; document.body.style.overflow = 'hidden'; burger.classList.add('is-open');
    });
    $$('[data-ecv-menu-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  }

  /* Galerie + miniatures */
  var gal = $('[data-ecv-gal]'), thumbs = $$('.ecv-thumb'), thumbTrack = $('[data-ecv-thumbs]');
  if (gal) {
    var current = 0;
    var setActive = function (i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var t = thumbs[i];
      if (t && thumbTrack) thumbTrack.scrollTo({ left: t.offsetLeft - thumbTrack.clientWidth / 2 + t.clientWidth / 2 });
    };
    var goTo = function (i) {
      i = Math.max(0, Math.min(thumbs.length - 1, i));
      gal.scrollTo({ left: gal.children[i].offsetLeft - gal.offsetLeft, behavior: 'smooth' });
      setActive(i);
    };
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { goTo(k); }); });
    var prev = $('[data-ecv-thumb-prev]'), next = $('[data-ecv-thumb-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    var raf;
    gal.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = gal.children[0].getBoundingClientRect().width + 4;
        var i = Math.round(gal.scrollLeft / w);
        if (i !== current) setActive(i);
      });
    }, { passive: true });
  }

  /* Offres : sélection, lignes de couleur, cadeaux */
  var bundles = $('[data-ecv-bundles]');
  if (bundles) {
    var bars = $$('.ecv-bar', bundles), tpl = $('[data-ecv-varrow]', bundles), gifts = $$('.ecv-gift', bundles);
    var fill = function (bar) {
      var box = $('.ecv-bar-vars', bar);
      if (box.childElementCount) return;
      var cap = document.createElement('p'); cap.className = 'ecv-var-cap'; cap.textContent = 'Couleur'; box.appendChild(cap);
      for (var n = 1; n <= +bar.dataset.rows; n++) {
        var row = tpl.content.firstElementChild.cloneNode(true);
        $('[data-n]', row).textContent = n;
        box.appendChild(row);
      }
    };
    var select = function (bar) {
      bars.forEach(function (b) { b.classList.toggle('is-selected', b === bar); });
      $('input', bar).checked = true;
      fill(bar);
      var g = +bar.dataset.gifts;
      gifts.forEach(function (el, k) { el.classList.toggle('is-on', k < g); });
    };
    bars.forEach(function (b) { b.addEventListener('click', function (e) { if (!e.target.closest('.ecv-sw')) select(b); }); });
    bundles.addEventListener('click', function (e) {
      var sw = e.target.closest('.ecv-sw');
      if (!sw) return;
      e.preventDefault();
      $$('.ecv-sw', sw.parentNode).forEach(function (x) { x.classList.toggle('is-on', x === sw); });
    });
    select($('.ecv-bar.is-selected', bundles) || bars[0]);
  }

  /* Ajouter au panier : une ligne de couleur = 1 serviette ; quantités regroupées par couleur, puis panier */
  var atc = $("[data-ecv-atc]");
  if (atc && bundles) {
    atc.addEventListener("click", function () {
      var err = $("[data-ecv-atc-err]"), map = {};
      try { map = JSON.parse(atc.dataset.variants || "{}"); } catch (x) {}
      var bar = $(".ecv-bar.is-selected", bundles), qty = {}, missing = false;
      $$(".ecv-var-row", bar).forEach(function (row) {
        var sw = $(".ecv-sw.is-on", row), id = sw && map[sw.getAttribute("aria-label")];
        if (id) qty[id] = (qty[id] || 0) + 1; else missing = true;
      });
      var items = Object.keys(qty).map(function (id) { return { id: +id, quantity: qty[id] }; });
      if (missing || !items.length) { err.textContent = "Produit indisponible pour le moment."; err.hidden = false; return; }
      err.hidden = true; atc.disabled = true;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || "Erreur"); }); location.href = "/cart?view=ma-debarbouillette"; })
        .catch(function (e) { err.textContent = e.message; err.hidden = false; atc.disabled = false; });
    });
  }

  /* Bouton « Je profite de l'offre » : remonte aux offres */
  $$('[data-ecv-totop]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); var t = $('[data-ecv-bundles]'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
  });

  /* Points du slider vidéo : suivent le défilement */
  var dots = $$('[data-ecv-vdots] span'), vtrack = $('[data-ecv-vtrack]');
  if (dots.length && vtrack) {
    setInterval(function () {
      var x = -new DOMMatrixReadOnly(getComputedStyle(vtrack).transform).m41;
      var step = Math.floor(x / (vtrack.firstElementChild.offsetWidth + 15));
      var i = vtrack.dataset.dir === 'droite' ? ((dots.length - (step % dots.length)) % dots.length) : step % dots.length;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }, 500);
  }

  /* Tri des avis */
  var sort = $('[data-ecv-sort]');
  if (sort) {
    var list = $('.ecv-tt-sort-list', sort);
    $('.ecv-tt-sort-btn', sort).addEventListener('click', function () { list.hidden = !list.hidden; sort.classList.toggle('is-open', !list.hidden); });
    $$('li:not(.ecv-tt-sort-title)', list).forEach(function (li) {
      li.addEventListener('click', function () { $$('li', list).forEach(function (x) { x.classList.toggle('is-on', x === li); }); list.hidden = true; sort.classList.remove('is-open'); });
    });
    document.addEventListener('click', function (e) { if (!sort.contains(e.target)) { list.hidden = true; sort.classList.remove('is-open'); } });
  }

  /* 20-10-2026 vitesse : photos clientes et vidéo du milieu chargées quand on arrive à ~2 écrans, pour laisser passer d'abord le haut de la page */
  var lazyLoad = function (els, root, run) {
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect(); els.forEach(run);
    }, { rootMargin: '1700px 0px' });
    io.observe(root || els[0]);
  };
  var ugc = $$('img[data-ecv-lazyimg]');
  lazyLoad(ugc, ugc.length && ugc[0].closest('.ecv-vslider'), function (img) {
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
  });
  $$('video.ecv-iwt-video').forEach(function (v) {
    lazyLoad([v], v, function () { v.autoplay = true; v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
  });

  /* Pied de page : listes ouvertes sur ordinateur */
  if (window.matchMedia('(min-width: 990px)').matches) $$('.ecv-foot-acc').forEach(function (d) { d.open = true; });
})();
